import CoursesApiService from "./api/CoursesApiService";
import { formatPayloadToQueryString } from "@/utils/formatters";

export const getCourses = async (payload, userToken) => {
    const queryString = formatPayloadToQueryString({
        search: payload.search,
        periodId: payload.periodId,
        organizationId: payload.organizationId,
        page: payload.page,
        perPage: payload.perPage
    });

    try {
        const response = await CoursesApiService.get(`/courses${queryString}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao buscar cursos', error);

        throw error;
    }
}

export const getCourseById = async (courseId, userToken) => {
    try {
        const response = await CoursesApiService.get(`/courses/${courseId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao buscar curso', error);

        throw error;
    }
}

export const createCourse = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.post('/courses', payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao criar curso', error);

        throw error;
    }
}

export const updateCourse = async (payload, userToken) => {
    const { id, ...course } = payload;

    try {
        const response = await CoursesApiService.put(`/courses/${id}`, course, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao atualizar curso', error);

        throw error;
    }
}

export const deleteCourse = async (courseId, userToken) => {
    try {
        await CoursesApiService.delete(`/courses/${courseId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
    } catch (error) {
        console.error('Erro ao deletar curso', error);

        throw error;
    }
}

export default {
    getCourses,
    getCourseById,
    createCourse,
    updateCourse,
    deleteCourse
}
